import { FormatListChecksIcon } from './FormatListChecksIcon';

/**
 * author: Austin Andrews
 * id 2B19EECF-71BF-41F3-B62A-468607BA0B47
 * name format-list-checks
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-list-checks.svg
 * tags
 * - Text / Content / Format 
 */
export const ToDoIcon = FormatListChecksIcon;
export default ToDoIcon